<template>
  <div class="container">
    <template>
      <basic-edit-form :html-page="htmlPage" />
      <v-btn
        class="px-10 my-10 text-body-2 float-left"
        color="primary darken-1"
        min-height="50px"
        min-width="100px"
        tile
        dark
        depressed
        @click="createHtmlPage"
      >
        作成
      </v-btn>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import router from '@/src/appRouter'
import BasicEditForm from './BasicEditForm'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    BasicEditForm
  },
  mixins: [headUtilsMixin],
  data () {
    return {
      pageTitle: 'HTMLページ作成',
      htmlPage: {}
    }
  },
  methods: {
    createHtmlPage () {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .post('/api/html_pages', {
          html_page: this.htmlPage
        })
        .then(({ data }) => {
          const htmlPageId = deserialize(data).data.id
          router.push({ name: 'adminHtmlPageEdit', params: { id: htmlPageId } })
          const payload = {
            status: 200,
            message: 'HTMLページを作成しました。'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => this.$store.dispatch('LoaderStore/hideLoader'))
    }
  }
}
</script>
